import axios from "@/libs/request";
import { getCloudApi, getBoxApi } from "@/config";
import CryptoJS from "crypto-js";

// 获取支付类型接口 用以获取支付类型与三方SDK上报信息
export const payType = (data) => axios.request({ url: "/pay/pay-type", data, unHint: true });
// 安卓应用宝内购回调请求
export const yybInnerPayRes = (data) => axios.request({ url: "/pay/pay-res/pay_type/22/sdk_version/3.0.1", data });
// 订单结果查询
export const queryOrderResult = (data) => axios.request({ url: "/pay/order/show", data });
// 下单
export const placeOrder = (data) => axios.request({ url: "/pay/order", data });
// 大额支付下单
export const placeLargeOrder = (data) => axios.request({ url: "/pay/large-amount/order", data });
// 有效代金券列表
export const voucherList = (data) => axios.request({ url: "/pay/voucher/effective/list", data });
// 已使用代金券列表接口
export const usedVoucherList = (data) => axios.request({ url: "/pay/voucher/used/list", data })
// 已失效代金券接口
export const invalidVoucherList = (data) => axios.request({ url: "/pay/voucher/invalid/list", data })
// 支付界面代金券列表接口
export const payVoucherList = (data) => axios.request({ url: "/pay/voucher/pay/list", data })
// 登录弹窗界面代金券列表接口
export const showVoucherList = (data) => axios.request({ url: "/pay/voucher/show/list", data })
// 微信二维码链接
export const getWxQrCode = (data) => axios.request({ url: '/pay/pay', data });

// 彩消订单查询
export const cXqueryOrder = (data) => axios.request({ url: "/order/order-status/52", data });


const getSign = (data) => {
  const secret = 'SdkClOuD87';
  return CryptoJS.MD5(`${JSON.stringify(data)}${secret}`).toString()
}

// 云挂机平台预支付接口
export const cloudOrderPreCreate = (data) => axios.request({ baseURL: getCloudApi(), url: '/platform-cloud-order/order/preCreate', data, third: true, headers: { CloudType: '2', CloudSign: getSign(data) } });
// 云挂机盒子购买接口
export const boxPayOrder = (data, token) => axios.request({ baseURL: getBoxApi(), url: '/wx-box-order/order/payOrder', data, third: true, headers: { Authorization: token } });
// 云挂机盒子续费接口
export const boxRenewPayOrder = (data, token) => axios.request({ baseURL: getBoxApi(), url: '/wx-box-order/order/renewPay', data, third: true, headers: { Authorization: token } });
// 云挂机盒子检查订单
export const boxCheckOrder = (data, token) => axios.request({ baseURL: getBoxApi(), url: '/wx-box-order/order/checkOrderStatus', data, third: true, headers: { Authorization: token } });
// 云挂机盒子埋点接口
export const boxBurn = (data, token) => axios.request({ baseURL: getBoxApi(), url: '/wx-box-user/user/event-track', data, third: true, headers: { Authorization: token } });

// 云挂机平台调用 通用支付接口
export const commonPayOrder = (data) => axios.request({ url: '/common/pay/order', data });
// 通用支付订单查询接口
export const orderCheck = (params) => axios.request({ url: "/common/pay/order-result", params, method: 'get' });
// 云挂机购买记录接口
export const commonPayOrderList = (data) => axios.request({ url: "/common/pay/order-list", data });
// 小游戏转移包判断礼包和隐藏微信支付
export const miniLeadPayConfig = (params) => axios.request({ url: "/activity-pay/config", params, method: 'get' });
// 小游戏转移包支付宝支付成功礼包
export const miniLeadPayGift = (data) => axios.request({ url: "/activity-pay/gift", data }); 

// 新增：内购商品ID接口，使用API_URL_WX域名
import { API_URL_WX } from '@/config/dev';
export const getInnerProductId = (data) => {
  // 开发环境下使用代理路径，生产环境使用完整URL
  const isDev = process.env.NODE_ENV === 'development';
  const url = '/pay/inner-product-id';
  const baseURL = isDev ? '' : API_URL_WX;

  return axios.request({ 
    baseURL, 
    url, 
    data 
  });
}; 

export const iapVerifier = (data) => {
  // 开发环境下使用代理路径，生产环境使用完整URL
  const isDev = process.env.NODE_ENV === 'development';
  const url = '/iapVerifier';
  const baseURL = isDev ? '' : API_URL_WX;

  return axios.request({ 
    baseURL, 
    url, 
    data 
  });
};